"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _setHeight = _interopRequireDefault(require("../setHeight"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function animateToggle(willOpen, ref, duration, onEndAnimate) {
  var target = ref.current;
  if (target && window.requestAnimationFrame) {
    var initHeight = willOpen ? 0 : target.offsetHeight;
    var finalHeight = willOpen ? target.offsetHeight : 0;
    (0, _setHeight["default"])(initHeight, finalHeight, target, duration, onEndAnimate);
  }
}
var _default = animateToggle;
exports["default"] = _default;
//# sourceMappingURL=animateToggle.js.map